import React, {useState} from "react";
import styles from "./login.module.css";
import { HiOutlineEnvelope } from "react-icons/hi2";
import axios from "axios";
import { Url } from "../../Constants/globals";
import Alert from "../../Components/Alert/alert";
import Loading from "../../Components/Loading/loading";

function ChangePasswordForm() {

  const [loading, setLoading] = useState("");
  const [alert, setAlert] = useState("");
  const [email, setEmail] = useState("");

  const handleChangePassword = async () => {
    await setAlert("");
    if(email.trim().length === 0){
      return setAlert(<Alert type={"error"}>Insira um email válido</Alert>);
    }
    await setLoading(<Loading/>);
    changePassword(email).then(() => {
      setLoading("");
      setAlert(<Alert type={"success"}>Foi enviado um email com indicações de recuperação</Alert>);
      setTimeout(() => {
        window.close();
      }, 1000);
    }).catch(() => {
      setLoading("");
      setAlert(<Alert type={"error"}>Este email não existe</Alert>);
    });
  };

  const changePassword = async (email) => {
    await axios.post(Url + "/users/password-recovery/", {
      email: email,
    });
  };

  return (
    <div className={styles.body}>
      {loading}
      {alert}
      <div className={styles.blur}/>
      <div className={styles.center}>
        <div className={styles.box}>
          <div className={styles.logo}/>
          <div className={styles.column}>
            <div className={styles.boxInput}>
              <HiOutlineEnvelope className={styles.iconsColor}/>
              <input
                className={styles.inputText}
                placeholder={"Email"}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    handleChangePassword();
                  }
                }}
              />
            </div>
          </div>
          <div className={styles.columnBtn}>
            <button className={styles.btn} onClick={() => handleChangePassword()}>Recuperar palavra-passe</button>
            <div className={styles.centerText}>
              <span onClick={() => window.location = "/"}>Regressar ao login</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordForm;